// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__3KOGj","clipboardAlert":"styles_clipboardAlert__hKK-A","ellipsis":"styles_ellipsis__br+xW"};